import React, { useMemo } from 'react'
import { useContext } from '../Context'
import { DataTool } from '@ztechapps/webui.data-tools'
import { fields } from './constants'

export const Toolbox = () => {
  const context = useContext()
  const { templateCategories } = context
  const fieldConfig = useMemo(() => {
    return fields(templateCategories)
  }, [templateCategories])

  return (
    <DataTool
      fieldsConfig={fieldConfig}
      searchPlaceHolder="Search the reports."
      components={{
        add: () => null,
        filter: () => null,
        sort: () => null,
      }}
      {...context}
    />
  )
}
